/**
 * Canonical URL helpers for SSR head + client Helmet.
 * Keep HTTPS, strip query/hash, and keep directory-style trailing slashes
 * consistent with sitemap / GSC (e.g. /i/how-it-works/).
 */

/** Paths that must end with a trailing slash (locale-aware). */
const FORCE_TRAILING_SLASH = [
  /^\/(?:pt-br\/)?i\/how-it-works\/?$/i,
  /^\/(?:pt-br\/)?markets\/?$/i,
]

/**
 * @param {string} pathname
 * @returns {string}
 */
/**
 * `/markets/sports/sports/...` repeats the sports segment. Returns the collapsed
 * path, or null when the path does not have that repeat.
 * @param {string} pathname
 * @returns {string|null}
 */
export function collapseDoubledSportsPath(pathname) {
  const path = pathname || '/'
  const next = path.replace(
    /^(\/pt-br)?\/markets\/sports\/sports(?=\/|$)/i,
    (_, prefix) => `${prefix || ''}/markets/sports`
  )
  return next === path ? null : next
}

export function normalizeSeoPathname(pathname) {
  const path = pathname || '/'
  for (const re of FORCE_TRAILING_SLASH) {
    if (re.test(path)) {
      return `${path.replace(/\/$/, '')}/`
    }
  }
  return path
}

/**
 * @param {string} raw Absolute or path-like URL
 * @returns {string}
 */
export function toCanonicalUrl(raw) {
  if (!raw) return ''
  try {
    const u = new URL(raw)
    u.protocol = 'https:'
    u.search = ''
    u.hash = ''
    // Consolidate www → apex so canonicals match the preferred host.
    if (u.hostname === 'www.futuur.com') u.hostname = 'futuur.com'
    u.pathname = normalizeSeoPathname(u.pathname || '/')
    return u.toString()
  } catch (_) {
    const cleaned = String(raw).split('?')[0].split('#')[0]
    try {
      const u = new URL(cleaned, 'https://futuur.com')
      if (u.hostname === 'www.futuur.com') u.hostname = 'futuur.com'
      u.pathname = normalizeSeoPathname(u.pathname || '/')
      return u.toString()
    } catch {
      return cleaned
    }
  }
}
